// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"87b0c955","348":"ad5620b3","742":"4947428d","802":"72d38240"}[chunkId] + ".chunk.css";
};